import { useState } from "react";
import axios from "axios";
import { base_url } from "../baseUrl";

const useCreateOrgUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get authentication token from localStorage
  const getHeaders = () => {
    const storedUser = localStorage.getItem('user');
    const token = storedUser ? JSON.parse(storedUser).token : null;
    
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  };

  const createOrgUser = async (payload) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(
        `${base_url}api/org-users`,
        payload,
        getHeaders()
      );
      setLoading(false);
      return res.data;
    } catch (err) {
      setLoading(false);
      setError(
        err.response?.data?.message || "Failed to create organisation user"
      );
      throw err;
    }
  };

  return { createOrgUser, loading, error };
};

export default useCreateOrgUser;

